// extracted by mini-css-extract-plugin
export var AnimateBG = "LoadingSection_AnimateBG__sX6ZD";
export var loadingSection = "LoadingSection_loadingSection__XYX5m";